import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MsalService } from '@azure/msal-angular';
import { Observable } from 'rxjs';
import { BaseApiService } from './api-base.service';

export interface MePrincipal {
  id: string;
  oid: string | null;
  email: string;
  name: string | null;
  staff_id: number | null;
  first_name: string | null;
  last_name: string | null;
  roles: string[];
  tier: 'roster' | 'reallocate' | null;
  staff_found: boolean;
  env: string;
}

@Injectable({
  providedIn: 'root'
})
export class UserService extends BaseApiService {
  constructor(http: HttpClient, msalService: MsalService) {
    super(http, msalService);
  }

  // The signed-in principal as the API resolves it for an eCase env (tier computed server-side)
  public getMe(env: string): Observable<MePrincipal> {
    return this.get<MePrincipal>(`${this.apiUrl}/users/me?env=${env}`);
  }
}
